// extracted by mini-css-extract-plugin
module.exports = {"container":"Prolitec_container__Xxh2e","logo":"Prolitec_logo__3iDck","description":"Prolitec_description__1Pkfg"};